import { BatchLogRecordProcessor } from '@opentelemetry/sdk-logs';
import type { LogRecordExporter, SdkLogRecord } from '@opentelemetry/sdk-logs';

import type { AttributeSource } from '../types/attribute-source';

export class EnrichedLogRecordProcessor extends BatchLogRecordProcessor {
  private readonly attributeSource: AttributeSource;

  constructor(exporter: LogRecordExporter, attributeSource: AttributeSource) {
    super(exporter);
    this.attributeSource = attributeSource;
  }

  override onEmit(logRecord: SdkLogRecord): void {
    logRecord.setAttributes(this.attributeSource.getAttributes());
    super.onEmit(logRecord);
  }
}
